import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.array.is-array.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.array.from.js";
import "core-js/modules/es.regexp.exec.js";
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import React from 'react';

// eslint-disable-next-line @typescript-eslint/no-restricted-imports -- replace with crystal-ui
import { Box, Dialog, Typography, makeStyles, GRAY } from '@applyboard/ui-components';
import { connect } from 'react-redux';
import CloseButtonCore from "../CloseButton/CloseButtonCore";
import FooterButton from "../FooterButton";
import DurationGraphics from "../DurationGraphics";
import { HeaderImg } from "../Images";
import { Routes, RestartProgressConstants } from "../Constants";
import { deleteState } from "../../../../store/Utilities/State";
import { initializeStore as initializeStoreAction } from "../../../../store/Actions/Actions";
import { getValidKeys } from "../../../../store/Selectors";
import { getFirstUnansweredQuestionRoute } from "../getFirstUnansweredQuestionRoute";
import { getDuration } from "./helper";
import useCefNavigation from "../../Hooks/useCefNavigation";
import { useCefEventTracker } from "../../Hooks/useCefEventTracker";
import { CefEvent, Platform, CefEventName } from "../../../../EventTracker";
import { useIsMobile } from "../useIsMobile";
var useStyles = makeStyles({
  closeButton: {
    position: 'absolute',
    top: function top(p) {
      return p.isMobile ? '30px' : '22px';
    },
    right: function right(p) {
      return p.isMobile ? '30px' : '22px';
    }
  },
  content: {
    margin: function margin(p) {
      return p.isMobile ? '72px 24px 40px 24px' : '112px 40px 40px 40px';
    }
  },
  description: {
    marginTop: function marginTop(p) {
      return p.isMobile ? '16px' : '24px';
    }
  },
  dialogPaper: {
    borderRadius: function borderRadius(p) {
      return p.isMobile ? 0 : '8px';
    }
  },
  footerButtons: {
    display: 'flex',
    flexDirection: function flexDirection(p) {
      return p.isMobile ? 'column' : 'row';
    },
    position: function position(p) {
      return p.isMobile ? 'absolute' : 'static';
    },
    bottom: function bottom(p) {
      return p.isMobile ? 0 : 'auto';
    },
    width: function width(p) {
      return p.isMobile ? '100%' : 'auto';
    }
  },
  modalElements: {
    display: 'flex',
    flexDirection: 'column',
    position: 'relative'
  },
  widthContainer: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    width: function width(p) {
      return p.isMobile ? '100%' : '520px';
    }
  },
  logo: {
    height: '112px',
    width: '112px'
  }
});
var RestartProgress = function RestartProgress(_ref) {
  var validKeys = _ref.validKeys,
    initializeStore = _ref.initializeStore,
    onExit = _ref.onExit;
  var isMobile = useIsMobile();
  var classes = useStyles({
    isMobile: isMobile
  });
  var navigate = useCefNavigation();
  var _useCefEventTracker = useCefEventTracker(),
    trackEvent = _useCefEventTracker.trackEvent;
  var _getDuration = getDuration(validKeys),
    _getDuration2 = _slicedToArray(_getDuration, 2),
    timeLeft = _getDuration2[0],
    questionsLeft = _getDuration2[1];
  var onRestartProgress = function onRestartProgress() {
    deleteState();
    initializeStore(null);
    var route = Routes.Eligibility.NationalityQuestion;
    trackEvent(CefEvent(CefEventName.ClickedRestartProgress, isMobile ? Platform.Mobile : Platform.Desktop));
    navigate(route);
  };
  var onResume = function onResume() {
    var firstUnansweredQuestionRoute = getFirstUnansweredQuestionRoute(validKeys);
    trackEvent(CefEvent(CefEventName.ClickedContinueWhereLeftOff, isMobile ? Platform.Mobile : Platform.Desktop));
    navigate(firstUnansweredQuestionRoute);
  };
  var closeButton = /*#__PURE__*/React.createElement(Box, {
    className: classes.closeButton
  }, /*#__PURE__*/React.createElement(CloseButtonCore, {
    onClick: onExit
  }));
  var image = /*#__PURE__*/React.createElement(HeaderImg, {
    className: classes.logo
  });
  var title = /*#__PURE__*/React.createElement(Box, {
    className: classes.title
  }, /*#__PURE__*/React.createElement(Typography, {
    style: {
      fontWeight: 600,
      color: GRAY[5]
    },
    variant: "h2"
  }, isMobile ? RestartProgressConstants.TitleMobile : RestartProgressConstants.TitleDesktop));
  var description = /*#__PURE__*/React.createElement(Box, {
    className: classes.description
  }, /*#__PURE__*/React.createElement(Typography, {
    style: {
      color: GRAY[10]
    },
    variant: "paragraph"
  }, RestartProgressConstants.Description));
  var content = isMobile ? /*#__PURE__*/React.createElement(Box, {
    className: classes.content
  }, image, /*#__PURE__*/React.createElement(Box, {
    my: "16px"
  }, title), /*#__PURE__*/React.createElement(DurationGraphics, {
    timeLeft: timeLeft,
    questionsLeft: questionsLeft
  }), description) : /*#__PURE__*/React.createElement(Box, {
    className: classes.content
  }, /*#__PURE__*/React.createElement(Box, {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between"
  }, /*#__PURE__*/React.createElement(Box, {
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-evenly"
  }, title, /*#__PURE__*/React.createElement(DurationGraphics, {
    timeLeft: timeLeft,
    questionsLeft: questionsLeft
  })), image), description);
  var footerButtons = /*#__PURE__*/React.createElement(Box, {
    className: classes.footerButtons
  }, /*#__PURE__*/React.createElement(FooterButton, {
    label: "Restart Progress",
    onClick: onRestartProgress,
    isBackButton: true
  }), /*#__PURE__*/React.createElement(FooterButton, {
    label: "Continue Where I Left Off",
    onClick: onResume
  }));
  return /*#__PURE__*/React.createElement(Dialog, {
    fullScreen: isMobile,
    open: true,
    classes: {
      paper: classes.dialogPaper
    }
  }, /*#__PURE__*/React.createElement(Box, {
    className: classes.widthContainer
  }, /*#__PURE__*/React.createElement(Box, {
    className: classes.modalElements
  }, closeButton, content), footerButtons));
};
var mapStateToProps = function mapStateToProps(state) {
  return {
    validKeys: getValidKeys(state)
  };
};
var connector = connect(mapStateToProps, {
  initializeStore: initializeStoreAction
});
export default connector(RestartProgress);